import { batterKeys, pitcherKeys, positionKeys, stateKeys } from "./publicKeys";

const RankingChallangeLineupSynergies = {
    synergies: [
        { 
            condition : { playerTypes: ["라이브", "시즌", "국가대표", "올스타"], requiredCount: 7},
            result : { positions : positionKeys, additionalState: 1, label: "모든 선수 능력치" } 
        },
        { 
            condition : { playerTypes: ["임팩트"], requiredCount: 5 },
            result : { positions : batterKeys, additionalState: 1, label: "모든 타자 모든 능력치" } 
        },
        { 
            condition : { playerTypes: ["시그니쳐"], requiredCount: 5 }, 
            result : { positions : pitcherKeys, additionalState: 1, label: "모든 투수 모든 능력치"  }
        }
    ], 
    reverseSynergy: {
        condition : { playerTypes: ["골든글러브", "올스타"], maxCount: 5},
        result : { positions : positionKeys, minusState: -2, maxMinusState: -6, label: "모든 선수 능력치" } 
    }
}

const RealtimeMatchLineupSynergies = {
    synergies: [
        { 
            condition : { playerTypes: ["라이브", "시즌", "국가대표", "올스타"], requiredCount: 3},
            result : { positions : positionKeys, additionalState: 1, label: "모든 선수 능력치" } 
        },
        { 
            condition : { playerTypes: ["임팩트"], requiredCount: 7 },
            result : { positions : batterKeys, additionalState: 1, label: "모든 타자 모든 능력치" } 
        },
        { 
            condition : { playerTypes: ["시그니쳐"], requiredCount: 6 }, 
            result : { positions : pitcherKeys, additionalState: 1, label: "모든 투수 모든 능력치" }
        }
    ], 
    reverseSynergy: {
        condition : { playerTypes: ["골든글러브", "올스타"], maxCount: 4},
        result : { positions : positionKeys, minusState: -2, maxMinusState: -6, label: "모든 선수 능력치"} 
    }
}

const ClubMatchLineupSynergies = {
    synergies: [
        { 
            condition : { playerTypes: ["라이브", "시즌", "국가대표", "올스타"], requiredCount: 7},
            result : { positions : positionKeys, additionalState: 1, label: "모든 선수 능력치" } 
        },
        { 
            condition : { playerTypes: ["임팩트"], requiredCount: 5 },
            result : { positions : batterKeys, additionalState: 1, label: "모든 타자 모든 능력치" } 
        },
        { 
            condition : { playerTypes: ["시그니쳐"], requiredCount: 5 }, 
            result : { positions : pitcherKeys, additionalState: 1, label: "모든 투수 모든 능력치" }
        }
    ], 
    reverseSynergy: {
        condition : { playerTypes: ["골든글러브", "올스타"], maxCount: 5},
        result : { positions : positionKeys, minusState: -2, maxMinusState: -6, label: "모든 선수 능력치" } 
    }
}

const LeagueModeLineupSynergies = {
    synergies: [
        { 
            condition : { playerTypes: ["라이브", "시즌", "국가대표", "올스타"], requiredCount: 3},
            result : { positions : positionKeys, additionalState: 1, label: "모든 선수 능력치" } 
        },
        { 
            condition : { playerTypes: ["임팩트"], requiredCount: 3 },
            result : { positions : batterKeys, additionalState: 1, label: "모든 타자 모든 능력치" } 
        },
        { 
            condition : { playerTypes: ["시그니쳐"], requiredCount: 3 }, 
            result : { positions : pitcherKeys, additionalState: 1, label: "모든 투수 모든 능력치" }
        }
    ], 
    reverseSynergy: {
        condition : { playerTypes: ["골든글러브", "올스타"], maxCount: 6},
        result : { positions : positionKeys, minusState: -2, maxMinusState: -6, label: "모든 선수 능력치" } 
    }
}

const SpecialMatchLineupSynergies = {
    synergies: [
        { 
            condition : { playerTypes: ["라이브", "시즌", "국가대표", "올스타"], requiredCount: 4},
            result : { positions : positionKeys, additionalState: 1, label: "모든 선수 능력치" } 
        },
        { 
            condition : { playerTypes: ["임팩트"], requiredCount: 4 },
            result : { positions : batterKeys, additionalState: 1, label: "모든 타자 모든 능력치" } 
        },
        { 
            condition : { playerTypes: ["시그니쳐"], requiredCount: 4 }, 
            result : { positions : pitcherKeys, additionalState: 1, label: "모든 투수 모든 능력치" }
        }
    ], 
    reverseSynergy: {
        condition : { playerTypes: ["골든글러브", "올스타"], maxCount: 6},
        result : { positions : positionKeys, minusState: -2, maxMinusState: -6, label: "모든 선수 능력치" } 
    }
}

export const synergyMap = {
    "랭킹 챌린지": RankingChallangeLineupSynergies,
    "실시간 매치": RealtimeMatchLineupSynergies,
    "클럽 대전": ClubMatchLineupSynergies,
    "리그 모드": LeagueModeLineupSynergies,
    "스폐셜 매치": SpecialMatchLineupSynergies
}

export function calculateSynergyStates(player, playerInfos, position) {

    let synergyStates = {'s1':0, 's2':0, 's3':0, 's4':0, 's5':0, 's6':0};

    if (!playerInfos || !playerInfos.selectedLineup) {
        return synergyStates;
    }

    const synergy = synergyMap[playerInfos.selectedLineup] || {};
    const synergies = synergy.synergies;
    const reverseSynergy = synergy.reverseSynergy;

    for (let synergy of synergies) {
        if (synergy.result.positions.includes(position)) {
            const currentNumber = getHowManyOfType(playerInfos, synergy.condition.playerTypes);

            if (currentNumber >= synergy.condition.requiredCount) {
                stateKeys.forEach(stateKey => {
                    synergyStates[stateKey] += synergy.result.additionalState;
                });
            }
        }
    }

    if (reverseSynergy && reverseSynergy.result.positions.includes(position)) {
        const currentNumber = getHowManyOfType(playerInfos, reverseSynergy.condition.playerTypes, true);

            if (currentNumber > reverseSynergy.condition.maxCount) {
            stateKeys.forEach(stateKey => {
                const minusCount = currentNumber - reverseSynergy.condition.maxCount;
                synergyStates[stateKey] += reverseSynergy.result.minusState * (minusCount > 3 ? 3 : minusCount);
            });
        }
    }

    return synergyStates;
}

function getHowManyOfType(playerInfos, playerTypes, isReverse = false) {

    const currentTeam = playerInfos.selectedTeam;
    let count = 0;
    
    positionKeys.forEach(positionKey => {
        const player = playerInfos[positionKey];
        if (player && playerTypes.includes(player.type)) {
            count += 1;
        }
    });

    if (isReverse){
        if (playerTypes.includes("골든글러브")) {
            for (let positionKey of positionKeys) {
                const player = playerInfos[positionKey];
                if (player && player.type === "골든글러브" && player.team === currentTeam) {
                    count -= 1;
                    break;
                }
            }
        }

        if (playerTypes.includes("올스타")) {
            for (let positionKey of positionKeys) {
                const player = playerInfos[positionKey];
                if (player && player.type === "올스타" && player.team === currentTeam) {    
                    count -= 1;
                }
            }
        }
    }

    return count;
}

export function getSynergyTexts(playerInfos) {

    let synergyDisplays = [];

    if (!playerInfos || !playerInfos.selectedLineup) {
        return synergyDisplays;
    }

    const synergy = synergyMap[playerInfos.selectedLineup] || {};
    const synergies = synergy.synergies;
    const reverseSynergy = synergy.reverseSynergy;

    for (let synergy of synergies) {
        const currentNumber = getHowManyOfType(playerInfos, synergy.condition.playerTypes);
    
        synergyDisplays.push({
            condition: `${synergy.condition.playerTypes.join(", ")} ${synergy.condition.requiredCount}장 이상`,
            currentNumber: currentNumber,
            targetNumber: synergy.condition.requiredCount,
            result: currentNumber >= synergy.condition.requiredCount ? `${synergy.result.label} +${synergy.result.additionalState}` : '없음',
            isPositive: currentNumber >= synergy.condition.requiredCount
        });
    }

    if (reverseSynergy) {
        const currentNumber = getHowManyOfType(playerInfos, reverseSynergy.condition.playerTypes, true);
        
        synergyDisplays.push({
            condition: `${reverseSynergy.condition.playerTypes.join(", ")} ${reverseSynergy.condition.maxCount}장 이하`,
            currentNumber: currentNumber,
            targetNumber: reverseSynergy.condition.maxCount,
            result: currentNumber > reverseSynergy.condition.maxCount ? `${reverseSynergy.result.label} ${reverseSynergy.result.minusState * (currentNumber - reverseSynergy.condition.maxCount)}` : '없음',
            isPositive: !(currentNumber > reverseSynergy.condition.maxCount)
        });
    }

    return synergyDisplays;
}


